import { createSelector, Selector } from 'reselect';
import { ComEnvJson, makeComEnvJson } from '../../../api/cstb/comEnv/makeComEnvJson';
import { selectLotsReport } from '../lotsReport.selector';
import { State } from '../../reducers';

export const selectComEnvJson: Selector<State, ComEnvJson> = createSelector(
  [selectLotsReport],
  (report) => makeComEnvJson(report)
);
